import script from "./platform-dashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./platform-dashboard.vue?vue&type=script&setup=true&lang=js"

import "./platform-dashboard.vue?vue&type=style&index=0&id=3b55d125&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b55d125"]])

export default __exports__